import { type Floor } from "@eisox/api/core-api";
import { Field, TextField } from "@eisox/design-system";

import { RoomsSelect } from "~/components/rooms-select";
import { m } from "~/paraglide/messages";
import type { EnhancedRoom } from "~/types/room.type";

import { normalizeRoomIds, type EditableAirHandlerUnitRoomAssociation } from "../helpers/association.helper";

const NAME = "RoomAssociationForm";

interface RoomAssociationFormProps {
  buildingId: string;
  association: EditableAirHandlerUnitRoomAssociation;
  floors: Floor[];
  rooms: EnhancedRoom[];
  onRoomIdsChange: (roomIds: string[]) => void;
}

const RoomAssociationForm: React.FC<RoomAssociationFormProps> = ({
  buildingId,
  association,
  floors,
  rooms,
  onRoomIdsChange,
}) => (
  <div className="gap-4 w-80 min-w-80 max-[1200px]:min-w-0 flex flex-col max-[1200px]:w-full">
    <Field.Root>
      <Field.Label>{m.name()}</Field.Label>
      <TextField.Root className="w-full" value={association.name} disabled />
    </Field.Root>
    <Field.Root>
      <Field.Label>{m.air_handler_unit_room_association_form_rooms()}</Field.Label>
      <RoomsSelect
        buildingId={buildingId}
        floors={floors}
        rooms={rooms}
        multiple
        value={association.roomIds}
        onValueChange={value => onRoomIdsChange(normalizeRoomIds(value as string[]))}
        align="start"
        className="w-full"
      />
    </Field.Root>
  </div>
);

RoomAssociationForm.displayName = NAME;

export { RoomAssociationForm };
export type { RoomAssociationFormProps };
